import { breakpoints } from "@brightagency/headstart-common";
import { transparentize } from "polished";
import styled, { css } from "styled-components";
import { zIndex } from "../../../../constants";
import { buttonResetStyles } from "../../../../utils";
import { colors } from "../../../../utils/colors";

export const SearchWrapper = styled.div`
    position: relative;
    display: flex;
    align-items: center;
`;

export const SearchInput = styled.input.attrs({})`
    border: 0;
    border-radius: 12px !important;
    width: 100%;
    height: 60px;
    padding: 16px 0px 16px 16px;
    font-size: 16px;
    color: ${colors.brandDark};

    &:focus {
        outline: none;
        box-shadow: 0 2px 5px ${transparentize(0.75, colors.brandMid)};
    }

    ${breakpoints.medium} {
        font-size: 18px;
    }
`;

export const CloseButton = styled.button`
    ${buttonResetStyles}
    position: absolute;
    top: 0;
    right: 0;
    height: 60px;
    width: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: ${colors.brandDark};

    &:hover {
        color: ${colors.brandMid};
    }
`;

export const Outer = styled.div`
    text-align: left;
    position: relative;
`;

export const Results = styled.div`
    box-shadow: 0 0 5px ${transparentize(0.8, "black")};
    border-radius: 8px 8px 8px 8px;
    background-color: white;
    position: absolute;
    top: calc(100% - 4px);
    left: 4px;
    width: calc(100% - 8px);
    max-height: 175px;
    overflow-y: auto;
    z-index: ${zIndex.autocompleteResults};
`;

const resultFocusStyles = css`
    background-color: hsl(0, 0%, 95%);
    border-left: 3px solid ${colors.brandDark};
`;

export const ResultRow = styled.button<{ isFocused?: boolean }>`
    ${buttonResetStyles}
    padding: 12px;
    color: ${colors.brandDark};
    border-left: 3px solid transparent;

    &:focus {
        ${resultFocusStyles}
    }

    ${({ isFocused }) => (isFocused ? resultFocusStyles : null)}
`;

export const InfoMessage = styled.div`
    background-color: hsl(0, 0%, 100%);
    padding: 12px;
    color: ${transparentize(0.5, "black")};
`;

export const ErrorMessage = styled.div`
    background-color: hsl(0, 0%, 95%);
    padding: 12px;
    color: red;
`;
